<template>
  <div class="table-responsive mb-0">
    <v-table
      class="table table-hover mb-0"
      ref="my-table"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="10"
      :data="tags"
    >
      <thead class="table-light" slot="head">
        <tr>
          <th>Tag Type</th>
          <th>Page Name</th>
          <th>Tag Name</th>
          <th>Status</th>
          <th class="booking-table">Action</th>
        </tr>
      </thead>
      <thead class="table-light" slot="head">
        <tr>
          <th>
            <b-form-select
              class="form-select"
              id="tag-type"
              placeholder="Filter data by tag type"
              v-model="filter.tag_type"
              :options="[
                { text: 'Filter By Tag', value: '' },
                { text: 'Text Value', value: 'text_value' },
                { text: 'Video', value: 'video' },
              ]"
              @change="filterTag('tag_type')"
            >
            </b-form-select>
          </th>
          <th></th>
          <th></th>
          <th>
            <b-form-select
              class="form-select"
              id="tag-type"
              placeholder="Filter data by status"
              v-model="filter.status"
              :options="[
                { text: 'Filter By Status', value: '' },
                { text: 'True', value: 1 },
                { text: 'False', value: 0 },
              ]"
              @change="filterTag('status')"
            >
            </b-form-select>
          </th>
          <th>
            <b-button
              variant="outline-primary"
              class="mt-1 ms-2"
              @click="clearFilter()"
            >
              Clear Filter
            </b-button>
          </th>
        </tr>
      </thead>
      <tbody
        class="infinite-list"
        slot="body"
        slot-scope="{ displayData }"
        v-if="!isDataLoading"
      >
        <tr v-for="(data, index) in displayData" :key="index">
          <td>
            <span class="text-capitalize" @click="updateTagData(data, 'video')">
              {{ data.tag_type ? data.tag_type.replaceAll("_", " ") : "-" }}
            </span>
          </td>
          <td>
            <span class="text-capitalize" @click="updateTagData(data, 'video')">
              {{ data.page_name ? data.page_name.replaceAll("_", " ") : "-" }}
            </span>
          </td>
          <td>
            <span class="text-capitalize" @click="updateTagData(data, 'video')">
              {{ data.tag_name ? data.tag_name.replaceAll("_", " ") : "-" }}
            </span>
          </td>
          <td>
            <div class="form-check form-switch my-2">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="data.is_active"
                @change="updateStatus(data.id, { is_active: data.is_active })"
              />
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <i
                class="fas fa-pencil-alt text-success mx-1"
                id="edit"
                @click="updateTagData(data, 'video')"
              />
              <i
                class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                @click="deleteTag(data.id)"
              ></i>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="number in 20" :key="number">
          <td class="placeholder-glow" v-for="no in 5" :key="no">
            <span class="placeholder w-100 placeholder-lg"></span>
          </td>
        </tr>
      </tbody>
      <tbody v-if="!isDataLoading && tags.length == 0">
        <tr>
          <td colspan="14" class="text-center">
            <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
            <p>
              <span class="text-secondary">No Data Found</span>
            </p>
          </td>
        </tr>
      </tbody>
    </v-table>
    <!-- Modal is use for update tag details -->
    <b-modal
      id="tag-form"
      centered
      title="Update tag"
      title-class="font-18"
      ref="tag-form"
      hide-footer
    >
      <div>
        <div class="container">
          <div class="row">
            <div class="col-12">
              <form @submit.prevent="submitForm()">
                <b-form-group class="mb-3" label="Name" label-for="tag_type">
                  <template slot="label">
                    Tag type <span class="text-danger">*</span>
                  </template>
                  <b-form-select
                    class="form-select"
                    id="tag-type"
                    v-model="form.tag_type"
                    :options="tagTypeOptions"
                    :class="{
                      'is-invalid': submitted && $v.form.tag_type.$error,
                    }"
                  >
                  </b-form-select>
                  <div
                    v-if="submitted && $v.form.tag_type.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.form.tag_type.required">
                      Tag type is required.
                    </span>
                  </div>
                </b-form-group>
                <b-form-group class="mb-3" label="Name" label-for="tag_type">
                  <template slot="label">
                    Page name <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="page_name"
                    type="text"
                    placeholder="Enter page name"
                    v-model.trim="form.page_name"
                    autocomplete="off"
                    :class="{
                      'is-invalid': submitted && $v.form.page_name.$error,
                    }"
                  />
                  <div
                    v-if="submitted && $v.form.page_name.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.form.page_name.required">
                      Page name is required.
                    </span>
                  </div>
                </b-form-group>
                <b-form-group class="mb-3" label="Name" label-for="tag_name">
                  <template slot="label">
                    Tag name <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="tag_name"
                    type="text"
                    placeholder="Enter tag name"
                    v-model.trim="form.tag_name"
                    autocomplete="off"
                  />
                  <div
                    v-if="submitted && $v.form.tag_name.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.form.tag_name.required">
                      Tag name is required.
                    </span>
                  </div>
                </b-form-group>
                <b-form-group class="mb-3" label="Name" label-for="tag_name">
                  <template slot="label"> Status </template>
                  <div class="form-check form-switch my-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.is_active"
                    />
                  </div>
                </b-form-group>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="d-flex align-items-center">
              <b-button
                variant="outline-primary"
                class="float-end mt-1 ms-2"
                type="submit"
                @click="submitForm()"
                :class="{
                  disabled: isBtnLoading,
                }"
              >
                <i
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  v-if="isBtnLoading"
                />
                Save
              </b-button>
              <b-button
                variant="outline-primary"
                class="float-end mt-1 ms-2"
                type="submit"
                @click="cancelSubmit()"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import kioskMetaService from "@/helpers/APIService/kioskmeta.service";
import { required } from "vuelidate/lib/validators";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import Swal from "sweetalert2";

export default {
  name: "Kiosk-Meta-Tags",
  data() {
    return {
      tagTypeOptions: [
        { text: "Text Label", value: "text_label" },
        { text: "Video", value: "video" },
      ],
      tags: [],
      isDataLoading: "",
      isBtnLoading: false,
      tagId: "",
      form: {
        tag_type: "",
        page_name: "",
        tag_name: "",
        is_active: true,
      },
      submitted: false,
      filter: {
        status: "",
        tag_type: "",
      },
    };
  },
  validations: {
    form: {
      tag_type: { required },
      page_name: { required },
      tag_name: { required },
    },
  },
  mounted() {
    this.getTagList();
  },
  methods: {
    // Method is use for get tag list
    async getTagList(filter = "") {
      try {
        this.isDataLoading = true;
        const response = await kioskMetaService.getTags(filter);
        if (response) {
          this.tags = response;
          this.isDataLoading = false;
        }
      } catch (error) {
        this.isDataLoading = false;
        errorHandler(error);
      }
    },
    // Method is use for apply filter
    async filterTag(filter_for) {
      if (filter_for == "status") {
        await this.getTagList(`?is_active=${this.filter.status}`);
      }
      if (filter_for == "tag_type") {
        await this.getTagList(`?tag_type=${this.filter.tag_type}`);
      }
    },
    // Method is use for clear filter
    clearFilter() {
      this.getTagList();
      this.filter = {
        status: "",
        tag_type: "",
      };
    },
    // Method is use for update tag name and details
    updateTagData(data) {
      this.tagId = data.id;
      this.form = {
        tag_type: data.tag_type,
        page_name: data.page_name,
        tag_name: data.tag_name,
        is_active: data.is_active,
      };
      this.$bvModal.show("tag-form");
    },
    // Method is use for update tag
    async submitForm() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        try {
          const response = await kioskMetaService.updateTag(
            this.tagId,
            this.form
          );
          if (response) {
            this.tags = this.tags.map((item) => {
              if (item.id == response.id) {
                item = response;
                return item;
              }
              return item;
            });
          }
          Middleware.notification("Tag updated successfully", "success");
          this.cancelSubmit();
        } catch (error) {
          this.isBtnLoading = false;
          errorHandler(error);
        }
      }
    },
    // Method is use for change status
    async updateStatus(id, data) {
      try {
        const response = await kioskMetaService.updateTag(id, data);
        if (response) {
          this.tags = this.tags.map((item) => {
            if (item.id == response.id) {
              item = response;
              return item;
            }
            return item;
          });
        }
        Middleware.notification("Status change successfully", "success");
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for delete tag
    deleteTag(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await kioskMetaService.deleteTag(id);
            if (response) {
              this.tags = this.tags.filter((item) => item.id !== id);
              Middleware.notification("Tag deleted successfully", "success");
            }
          } catch (error) {
            errorHandler(error);
          }
        }
      });
    },
    // Method is use for cancel tag modal and reset data
    cancelSubmit() {
      this.form = {
        tag_type: "",
        page_name: "",
        tag_name: "",
        is_active: true,
      };
      this.submitted = false;
      this.isBtnLoading = false;
      this.$bvModal.hide("tag-form");
    },
  },
};
</script>
